import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import Button from "components/basic/button";
import Typography from "components/basic/typography";

import { statusMeta } from "../../helpers/attendeeStatus";
import { AttendeeStatus, Booking } from "../../../../types";
import { BookingResponseType, ProposedTime } from "../../../../bookingsApi";
import RescheduleForm from "./components/RescheduleForm";

const CustomerResponse: React.FC<{
  booking: Booking;
  myStatus?: AttendeeStatus;
  responding?: boolean;
  onRespond: (response: BookingResponseType, proposed?: ProposedTime) => void;
}> = ({ booking, myStatus, responding, onRespond }) => {
  const theme = useTheme();
  const { t } = useTranslation("calendar");
  const meta = statusMeta(myStatus, theme);
  const [showReschedule, setShowReschedule] = useState(false);

  return (
    <Box>
      <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
        {t("details.your_response")}
      </Typography>
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ mt: 0.5 }}
      >
        <meta.Icon sx={{ fontSize: 16, color: meta.color }} />
        <Typography variant="body2" style={{ color: meta.color }}>
          {meta.label}
        </Typography>
      </Stack>

      {!showReschedule ? (
        <Stack spacing={1} sx={{ mt: 1.5 }}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            disabled={responding}
            startAdornment={<CheckCircleIcon fontSize="small" />}
            onClick={() => onRespond("accept")}
          >
            {t("details.accept")}
          </Button>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              color="warning"
              fullWidth
              disabled={responding}
              onClick={() => setShowReschedule(true)}
            >
              {t("details.reschedule")}
            </Button>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              disabled={responding}
              onClick={() => onRespond("decline")}
            >
              {t("details.decline")}
            </Button>
          </Stack>
        </Stack>
      ) : (
        <RescheduleForm
          booking={booking}
          responding={responding}
          onCancel={() => setShowReschedule(false)}
          onSubmit={(proposed) => onRespond("reschedule", proposed)}
        />
      )}
    </Box>
  );
};

export default CustomerResponse;
